import * as yup from 'yup';

// The simplified triage screen has one primary action - Accept for assessment -
// so this schema validates the acceptance fields only. Alternative decisions
// (return, reject, duplicate) capture their rationale in their own small dialogs,
// not in this form.
const YES_NO_VALUES: string[] = ['Yes', 'No'];

export const triageSchema = yup.object({
  changeManager: yup.array(yup.string().required()).default([]).length(1, 'Select a change manager.'),

  targetDate: yup.string().default('').required('A target date is required.'),

  changeCategory: yup.array(yup.string().required()).default([]).length(1, 'Select a change category.'),

  // One meaningful scope field replaces the former separate change type and scope.
  scopeType: yup.array(yup.string().required()).default([]).length(1, 'Select a scope.'),

  criticality: yup.array(yup.string().required()).default([]).length(1, 'Select a criticality.'),

  assessorFunctions: yup.array(yup.string().required()).default([]).min(1, 'Select at least one assessor function.'),

  // Applied template stays read-only on the page; kept here so the optional
  // "change template" overflow action can drive it when allowed.
  appliedTemplate: yup.array(yup.string().required()).max(1).default([]),

  immediateContainmentRequired: yup.string().oneOf(YES_NO_VALUES).default('No'),

  containmentDescription: yup.string().when('immediateContainmentRequired', {
    is: 'Yes',
    then: (schema) => schema.trim().required('Describe the containment.'),
    otherwise: (schema) => schema.default(''),
  }),

  containmentOwner: yup
    .array(yup.string().required())
    .default([])
    .when('immediateContainmentRequired', {
      is: 'Yes',
      then: (schema) => schema.length(1, 'Select a containment owner.'),
    }),

  containmentDueDate: yup
    .string()
    .default('')
    .when('immediateContainmentRequired', {
      is: 'Yes',
      then: (schema) => schema.required('A containment due date is required.'),
    }),
});

export type TTriageFormData = yup.InferType<typeof triageSchema>;

export const DEFAULT_TRIAGE_FORM: TTriageFormData = {
  changeManager: [],
  targetDate: '',
  changeCategory: [],
  scopeType: [],
  criticality: [],
  assessorFunctions: [],
  appliedTemplate: [],
  immediateContainmentRequired: 'No',
  containmentDescription: '',
  containmentDueDate: '',
  containmentOwner: [],
};
